// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__bdbvu","disabled":"FileBtn_disabled__1FUrH","warn":"FileBtn_warn__3r-xf","fade":"FileBtn_fade__2yjB8"};